import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import Modal from 'components/Modal'
import OpenHours from 'components/OpenHours'
import OpeningTimes from 'components/OpeningTimes'
import openingHoursUtils from 'utils/openingHours'

const VillageOpenHours = ({
  background,
  openingHoursExceptions,
  openingHoursLabels,
  village,
}) => {
  const villageOpenTimesModalRef = useRef()
  let result = false

  if (
    village &&
    village.openingHours &&
    openingHoursLabels &&
    openingHoursExceptions
  ) {
    const globalLabels = openingHoursLabels.edges[0].node
    const villageOpeningHours = village.openingHours
    const villageExceptions = openingHoursExceptions.exceptions.reduce(
      openingHoursUtils.reduceExceptions,
      {}
    )
    let villageHoursLabel = ''
    let showIcon = true
    if (village.openingStatusLabel) {
      villageHoursLabel = village.openingStatusLabel
      showIcon = false
    } else {
      villageHoursLabel = openingHoursUtils.getOpeningHours(
        villageOpeningHours,
        globalLabels,
        {
          villageExceptions,
        }
      )
    }

    const { villageSlug } = village
    const locale = village.home[0] && village.home[0].locale

    const villageOpenHoursProps = {
      statusLabel: globalLabels.villageRibbonLabel,
      hoursLabel: villageHoursLabel,
      background,
      onClick: () => {
        if (
          villageOpenTimesModalRef &&
          villageOpenTimesModalRef.current &&
          !village.openingStatusLabel
        ) {
          // @ts-ignore
          villageOpenTimesModalRef.current.openModal()
        }
      },
      showIcon,
    }
    const villageHours = openingHoursUtils.getWeeklyOpeningHours(
      villageOpeningHours,
      globalLabels,
      {
        numberOfWeeks: 1,
        villageExceptions,
      }
    )

    result = (
      <>
        <OpenHours {...villageOpenHoursProps} />
        <Modal ref={villageOpenTimesModalRef}>
          {villageHours.map((hours, index) => (
            <OpeningTimes
              key={`week_${index.toString()}`}
              conditionsCopy={
                villageOpeningHours.footNoteCopy &&
                villageOpeningHours.footNoteCopy.footNoteCopy
              }
              openingTimesLink={`/${villageSlug}/${locale}/${(villageOpeningHours &&
                villageOpeningHours.pageType &&
                villageOpeningHours.pageType.slug) ||
                'opening-hours'}`}
              openingTimesLinkLabel={globalLabels.moreOpeningHoursCtaCopy}
              times={hours}
              title={globalLabels.villageHeading}
              isModal
              villageName={village.name}
            />
          ))}
        </Modal>
      </>
    )
  }

  return result
}

VillageOpenHours.propTypes = {
  background: PropTypes.string,
  openingHoursExceptions: PropTypes.shape({
    exceptions: PropTypes.instanceOf(Array),
  }),
  openingHoursLabels: PropTypes.shape({
    edges: PropTypes.arrayOf(
      PropTypes.shape({
        node: PropTypes.instanceOf(Object),
      })
    ),
  }),
  village: PropTypes.instanceOf(Object),
}

VillageOpenHours.defaultProps = {
  background: 'White',
  openingHoursExceptions: {},
  openingHoursLabels: {},
  village: {},
}

export default VillageOpenHours
